"use strict";Object.defineProperty(exports,"__esModule",{value:!0});exports.noop=function(){return null};
